import { $get } from '@/utils/http.js'

export default {
  // home信息
  queryHomeData: function () {
    return $get('home_data')
  },
  // 最近8条交易记录
  recentTransactionRecords: function () {
    return $get('recent_transaction_records')
  },
  // 最近8个区块
  recentBlockHeight: function () {
    return $get('recent_block_height')
  },

  // 商品信息
  queryAssetInfo: function (params) {
    return $get('query_asset_info', params)
  },

  // 交易信息
  queryTransaction: function (params) {
    return $get('query_transaction', params)
  },

  // 地址信息
  queryAddress: function (params) {
    return $get('query_address', params)
  },

  // NTT交易查询
  queryNttTrade: function (params) {
    return $get('queryIntegralReceipt', params)
  }
}


// WEBPACK FOOTER //
// ./src/api/index.js